import {
	AvailabilityRequestModel,
	PasswordSimilarityModel,
} from "@api-types/partner-registration/AvailabilityRequestModel";
import { CreateUserDto } from "@data-types/membership/registration";
import CaptchaService from "@services/captcha/CaptchaService";
import { httpClient } from "@utils";
import { getApplicationHeaders } from "@utils";

class PlatformPartnerRegistrationApiService {
	static get baseUrl() {
		return `${WEBPACK_BASE_ADDRESS}platform/tw/partners`;
	}

	static getRequestHeaders = () => {
		const appHeaders = getApplicationHeaders();
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	static checkUserNameAvailability(
		body: AvailabilityRequestModel
	): Promise<boolean> {
		return httpClient.post(
			`${this.baseUrl}/user-validation/username-availability`,
			JSON.stringify(body),
			this.getRequestHeaders(),
			{
				responseType: "json",
			}
		);
	}

	static checkEmailAvailability(body: AvailabilityRequestModel) {
		return httpClient.post(
			`${this.baseUrl}/user-validation/email-availability`,
			JSON.stringify(body),
			this.getRequestHeaders(),
			{
				responseType: "json",
			}
		);
	}

	static checkPasswordSimilarity(body: PasswordSimilarityModel) {
		return httpClient.post(
			`${this.baseUrl}/user-validation/password-validity`,
			JSON.stringify(body),
			this.getRequestHeaders(),
			{ responseType: "json" }
		);
	}

	static async registerPartner(body: CreateUserDto, shopId: string) {
		const token = await CaptchaService.executeCaptcha(
			"partnerRegistration"
		);

		if (token) {
			body.challengeResponse = token;
		}

		return httpClient.post(
			`${this.baseUrl}/registration/web`,
			JSON.stringify(body),
			{
				...this.getRequestHeaders(),
				"Shop-Id": shopId,
			}
		);
	}
}

export default PlatformPartnerRegistrationApiService;
